import React, { useEffect, useState } from "react"

import {
  Col,
  Row,
  Card,
  CardBody,
  // CardTitle,
  // CardSubtitle,
  // CardImg,
  // CardText,
  // CardHeader,
  // CardImgOverlay,
  // CardFooter,
  // CardDeck,
  Container,
  Label,
  Input,
  InputGroup,
  Form,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Spinner,
  Tooltip,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

// action
import { apiError } from "../../store/actions"
import {
  createQuestionaireCategory,
  createQuestionaireCategoryReset,
} from "../../store/actions"
import { get, post, put } from "helpers/api_helper"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import { isEmpty } from "lodash"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import Spinners from "components/Common/Spinner"
import useQuestionnaireStore from "../../zustand/store/QuestionnaireModule"
import fn_helper from "helpers/fn_helper"
import UploadFileAPI from "components/UploadFileAPI"
import useInterviewStore from "../../zustand/store/InterviewDialogModule"

const DEF_OPTION_GENDER = [
  {
    label: "Any",
    value: "any",
  },
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
]

const DEF_OPTION_NATIONALITY = [
  {
    label: "Any",
    value: "any",
  },
  {
    label: "Thai",
    value: "Thai",
  },
]

const DEF_OPTION_MATIAL_STATUS = [
  {
    label: "Any",
    value: "any",
  },
  {
    label: "Single",
    value: "Single",
  },
  {
    label: "Married",
    value: "Married",
  },
]

const LANG_CODE_OPTION = [
  { id: "en", name: "English" },
  { id: "es", name: "Spanish" },
  { id: "fr", name: "French" },
  { id: "de", name: "German" },
  { id: "it", name: "Italian" },
  { id: "nl", name: "Dutch" },
  { id: "pt", name: "Portuguese" },
  { id: "ru", name: "Russian" },
  { id: "zh", name: "Mandarin Chinese" },
  { id: "ja", name: "Japanese" },
  { id: "ko", name: "Korean" },
  { id: "ar", name: "Arabic" },
  { id: "hi", name: "Hindi" },
  { id: "bn", name: "Bengali" },
  { id: "pa", name: "Punjabi" },
  { id: "ur", name: "Urdu" },
  { id: "te", name: "Telugu" },
  { id: "ta", name: "Tamil" },
  { id: "ml", name: "Malayalam" },
  { id: "gu", name: "Gujarati" },
  { id: "mr", name: "Marathi" },
  { id: "kn", name: "Kannada" },
  { id: "kok", name: "Konkani" },
  { id: "si", name: "Sinhala" },
  { id: "bo", name: "Tibetan" },
  { id: "ne", name: "Nepali" },
  { id: "mn", name: "Mongolian" },
  { id: "my", name: "Burmese" },
  { id: "km", name: "Khmer" },
  { id: "lo", name: "Lao" },
  { id: "vi", name: "Vietnamese" },
  { id: "th", name: "Thai" },
  { id: "id", name: "Indonesian" },
  { id: "tl", name: "Filipino" },
  { id: "ms", name: "Malay" },
  { id: "jv", name: "Javanese" },
  { id: "zu", name: "Zulu" },
  { id: "af", name: "Afrikaans" },
  { id: "st", name: "Sesotho" },
  { id: "tn", name: "Tswana" },
  { id: "xh", name: "Xhosa" },
  { id: "ny", name: "Chichewa" },
  { id: "so", name: "Somali" },
  { id: "yo", name: "Yoruba" },
  { id: "ig", name: "Igbo" },
  { id: "gaa", name: "Ga" },
  { id: "tw", name: "Twi" },
  { id: "ak", name: "Akan" },
  { id: "fat", name: "Fante" },
  { id: "xmf", name: "Mingrelian" },
  { id: "ka", name: "Georgian" },
]

const InterviewDialogTemplate = props => {
  const { pageView = "create" } = props

  const navigate = useNavigate()

  const { interviewDialogId } = useParams()

  const [contentDetailLoading, setContentDetailLoading] = useState(false)
  const [isCreateInterviewDialog, setIsCreateInterviewDialog] = useState(false)
  const [isEditInterviewDialog, setIsEditInterviewDialog] = useState(false)

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    lang_code: Yup.string().max(255).required("Select Language Code"),
    interview_name: Yup.string()
      .max(60)
      .required("Please Enter Interview Name"),
    number_speakers: Yup.number()
      .integer()
      .positive()
      .required("Please Enter Number Speakers")
      .min(1)
      .max(99),
    file_url: Yup.string().required("Please Upload Interview Audio File"),
  })

  const [updatedValidationSchema, setUpdatedValidationSchema] =
    useState(validationSchema)

  useEffect(() => {
    // If in edit mode, remove file_url validation requirement
    if (pageView !== "create") {
      const updatedSchema = Yup.object({
        lang_code: Yup.string().max(255).required("Select Language Code"),
        interview_name: Yup.string()
          .max(60)
          .required("Please Enter Interview Name"),
        number_speakers: Yup.number()
          .integer()
          .positive()
          .required("Please Enter Number Speakers")
          .min(1)
          .max(99),
        // Remove the required validation for file_url in edit mode
        file_url: Yup.string(),
      })
      setUpdatedValidationSchema(updatedSchema)
    }
  }, [pageView])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: pageView == "create" ? undefined : "",
      file_name: "",
      interview_name: "",
      number_speakers: "",
      lang_code: "",
      file_url: "",
    },
    validationSchema: updatedValidationSchema,
    onSubmit: async values => {
      try {
        if (pageView == "create") {
          setIsCreateInterviewDialog(true)
          await post(
            process.env.REACT_APP_BACKEND_URL +
              "/v1/admin/interview-dialog/create",
            {
              filename: values.file_name,
              name: values.interview_name,
              fileUrl: values.file_url,
              language: values.lang_code,
              numberSpeakers: parseInt(values.number_speakers),
            }
          )
        } else {
          setIsEditInterviewDialog(true)
          await put(
            process.env.REACT_APP_BACKEND_URL +
              "/v1/admin/interview-dialog/" +
              interviewDialogId +
              "/edit",
            {
              filename: values.file_name,
              name: values.interview_name,
              language: values.lang_code,
              numberSpeakers: parseInt(values.number_speakers),
            }
          )
        }
        setTimeout(() => {
          navigate("/interviewDialog")
          if (isCreateInterviewDialog) {
            setIsCreateInterviewDialog(false)
          } else if (isEditInterviewDialog) {
            setIsEditInterviewDialog(false)
          }
        }, 3000)
      } catch (error) {
        console.error("Error creating interview:", error)
      }
    },
  })

  const preFillForm = (formData = {}) => {
    validation.setFieldValue("id", formData.id ?? null)
    validation.setFieldValue("interview_name", formData.name ?? null)
    validation.setFieldValue("number_speakers", formData.numberspeaker ?? null)
    validation.setFieldValue("lang_code", formData.language ?? null)
    validation.setFieldValue("file_name", formData.filename ?? null)
    validation.setFieldValue("file_url", formData.fileUrl ?? null)
  }

  const API = {
    fetchContent: async () => {
      setContentDetailLoading(true)

      const result = await get(
        process.env.REACT_APP_BACKEND_URL +
          "/v1/admin/interview-dialog?id=" +
          interviewDialogId
      )
      const resData = result.resultData
      console.log("🚀 ~ fetchContent: ~ resData:", resData)

      //PREFILE INPUT FORM
      preFillForm(resData[0])

      setContentDetailLoading(false)
    },
  }

  useEffect(() => {
    if (pageView !== "create") {
      API.fetchContent()
    }
  }, [])

  if (contentDetailLoading && pageView !== "create") {
    return <Spinners setLoading={setContentDetailLoading} />
  }

  const PageAction = pageView
  document.title =
    `Interview Dialog | ${PageAction} Interview Dialog | ` +
    process.env.REACT_APP_CMS_TITLE

  return (
    <React.Fragment>
      {(isCreateInterviewDialog || isEditInterviewDialog) && (
        <Spinner
          color="primary"
          className="position-absolute top-50 start-50"
        />
      )}
      {!isCreateInterviewDialog && !isEditInterviewDialog && (
        <div className="page-content">
          <Container fluid={false}>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={"Interview Dialog"}
              breadcrumbItems={[
                { title: "Interview Dialog", link: "interviewDialog" },
                {
                  title:
                    pageView === "create"
                      ? "Create Interview File"
                      : "Edit Interview File",
                  link: pageView === "create" ? "create" : "edit",
                },
              ]}
            />
            <Row>
              <Col>
                <FormikProvider value={validation}>
                  <Form
                    className="form-horizontal"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Card>
                      <CardBody>
                        <Row className="mb-3">
                          <h5 className="mb-3">
                            {_.startCase(pageView)} Interview
                          </h5>
                          <Row className="mb-3">
                            <Col className="col-12">
                              <label
                                htmlFor="interview_name"
                                className="col-md-2 col-form-label"
                              >
                                Name{" "}
                                <span
                                  className="text-danger ml-1"
                                  aria-label="required"
                                >
                                  *
                                </span>
                              </label>
                              <div className="col-md-4">
                                <Input
                                  id="interview_name"
                                  className="form-control"
                                  type="text"
                                  placeholder="eg. Interview_name"
                                  name="interview_name"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.interview_name}
                                  invalid={
                                    validation.touched.interview_name &&
                                    validation.errors.interview_name
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.interview_name &&
                                validation.errors.interview_name ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.interview_name}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col className="col-12">
                              <label
                                htmlFor="category_name"
                                className="col-md-2 col-form-label"
                              >
                                Number speakers{" "}
                                <span
                                  className="text-danger ml-1"
                                  aria-label="required"
                                >
                                  *
                                </span>
                              </label>
                              <div className="col-md-4">
                                <Input
                                  id="number_speakers"
                                  className="form-control"
                                  type="text"
                                  placeholder="eg. 8"
                                  name="number_speakers"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.number_speakers}
                                  invalid={
                                    validation.touched.number_speakers &&
                                    validation.errors.number_speakers
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.number_speakers &&
                                validation.errors.number_speakers ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.number_speakers}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col className="col-12">
                              <label
                                htmlFor="category_name"
                                className="col-md-2 col-form-label"
                              >
                                Language{" "}
                                <span
                                  className="text-danger ml-1"
                                  aria-label="required"
                                >
                                  *
                                </span>
                              </label>
                              <div className="col-md-4">
                                <Select
                                  id="lang_code"
                                  placeholder="Select Language"
                                  value={fn_helper.FNFORM.getObjectValue(
                                    LANG_CODE_OPTION,
                                    `${validation.values.lang_code}`
                                  )}
                                  onChange={value =>
                                    validation.setFieldValue(
                                      "lang_code",
                                      value.id
                                    )
                                  }
                                  getOptionValue={option => option.id}
                                  getOptionLabel={option => option.name}
                                  options={LANG_CODE_OPTION}
                                  className={`select2-selection ${
                                    validation.touched.lang_code &&
                                    validation.errors.lang_code
                                      ? "input-err"
                                      : ""
                                  }`}
                                  isDisabled={pageView === "view"}
                                />

                                {validation.touched.lang_code &&
                                validation.errors.lang_code ? (
                                  <div
                                    type="invalid"
                                    className="invalid-feedback d-block"
                                  >
                                    {validation.errors.lang_code}
                                  </div>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                        </Row>
                        <Row className="">
                          <Col className="col-12">
                            <div className="col-md-6 ">
                              {" "}
                              <UploadFileAPI
                                isEditMode={
                                  pageView === "create" ? false : true
                                }
                                upload="Audio"
                                value={validation.values.file_url}
                                prefixName="banner-chat"
                                label="Upload Interview Dialog"
                                description="description"
                                onChange={([
                                  fileUrl = null,
                                  fileName = null,
                                ]) => {
                                  console.log(fileUrl, fileName)
                                  validation.setFieldValue("file_url", fileUrl)
                                  validation.setFieldValue(
                                    "file_name",
                                    fileName
                                  )
                                }}
                              />
                              {validation.touched.file_url &&
                              validation.errors.file_url ? (
                                <div className="invalid-feedback d-block">
                                  {validation.errors.file_url}
                                </div>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3 ">
                          <Col className="col-12">
                            <span
                              className="text-danger ml-1 "
                              aria-label="remark-upload"
                            >
                              Please upload high-quality audio where the voices
                              of all speakers are clear.
                            </span>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Button
                                type="submit"
                                color="primary"
                                className="btn btn-primary waves-effect waves-light"
                              >
                                {_.startCase(pageView)} Interview{" "}
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Form>
                </FormikProvider>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </React.Fragment>
  )
}

export default withTranslation()(InterviewDialogTemplate)
